export function sendFormDataToWebjack(props) {
  props.params = props.params || [];
  props.cookies = props.cookies || [];

  const url = "https://webjack.ru/webhooks/form/" + props.webhook + "/";

  const params = JSON.parse(localStorage.getItem("__wj_params") || "{}");
  const urlParams = new URLSearchParams(window.location.search.substring(1));
  props.params.forEach((name) => {
    const value = urlParams.get(name);
    if (value) params[name] = value;
  });
  localStorage.setItem("__wj_params", JSON.stringify(params));

  const cookies = new Map(
    (document.cookie || "").split(";").map((item) => {
      const delim = item.indexOf("=");
      const key = item.substring(0, delim);
      const value = decodeURIComponent(item.substring(delim + 1));
      return [key, value];
    })
  );

  function getParams() {
    const r = {};
    props.params.forEach((name) => {
      r[name] = params[name];
    });
    return r;
  }

  function getCookies() {
    const r = {};
    props.cookies.forEach((name) => {
      r[name] = cookies.get(name);
    });
    return r;
  }

  const formdata = new FormData();
  Object.keys(props.values).forEach((key) => {
    formdata.append(key, props.values[key]);
  });

  formdata.append("__wj_params", JSON.stringify(getParams()));
  formdata.append("__wj_cookies", JSON.stringify(getCookies()));

  const xhr = new XMLHttpRequest();
  xhr.open("POST", url, true);
  xhr.send(formdata);
}
